/// <amd-module name="Pipeline/Analytics/PipelineDurationCommon/ChartSeries/PipelineDurationChartSeries" />
import * as ChartSeries from "Analytics/Shared/ChartSeries/ChartSeries";
import * as ChartDataConverter from "Analytics/Shared/Common/Utils/ChartDataConverter";
import * as Resources from "Pipeline/Analytics/PipelineDurationCommon/Resources";

export class PipelineDurationChartSeries extends ChartSeries.ChartSeries {
    public get name(): string {
        return Resources.PipelineDuration;
    }

    public get color(): string {
        return PipelineDurationColorPalette;
    }

    public get values(): number[] {
        return ChartDataConverter.formatData(this._data);
    }
}

const PipelineDurationColorPalette = "#0078d4";
